/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Common_Fieldoptional1Inputs */

const en_common_fieldoptional1 = /** @type {(inputs: Common_Fieldoptional1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (optional)`)
};

/**
* | output |
* | --- |
* | "{name} (optional)" |
*
* @param {Common_Fieldoptional1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_fieldoptional1 = /** @type {((inputs: Common_Fieldoptional1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Fieldoptional1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_fieldoptional1(inputs)
});
export { common_fieldoptional1 as "common_fieldOptional" }